import { FC } from 'react';

import { Box } from '@mui/material';

import { IModalProps as Props } from 'interfaces/auth';

import { ModalComponent } from 'components/_basic/ModalComponent/ModalComponent';
import { Stepper } from 'components/_basic/Stepper/Stepper';

import {
  SetUpPasswordContextProvider,
  useSetUpPasswordContext,
} from './SetUpPasswordContextProvider/SetUpPasswordContextProvider';
import { EnterCodeStep, EnterEmailStep } from './SetUpPasswordForms';

import styles from './SetUpPassword.module.scss';

export const SetUpPassword: FC<Props> = ({ isModalOpened, onModalClose}) => {
  const stepArray = [EnterEmailStep, EnterCodeStep];

  return (
    <SetUpPasswordContextProvider isModalOpened={isModalOpened}>
      <ModalComponent open={isModalOpened} onClose={onModalClose}>
        <Box className={styles.setUpPasswordModalWrapper}>
          <Stepper useModalContext={useSetUpPasswordContext} stepForms={stepArray} onClose={onModalClose} />
        </Box>
      </ModalComponent>
    </SetUpPasswordContextProvider>
  );
};
